import { Injectable } from '@angular/core';

import { State, Selector, Action, StateContext } from '@ngxs/store';
import { PublicStateActions } from './public.actions';

export interface PublicStateModel {
    showSplitpane: boolean;
}

const defaults = {
    showSplitpane: true,
};

@State<PublicStateModel>({
    name: 'public',
    defaults,
})
@Injectable({ providedIn: 'root' })
export class PublicState {
    constructor() {}

    @Selector()
    static showSplitpane({ showSplitpane }: PublicStateModel): boolean {
        return showSplitpane;
    }

    @Action(PublicStateActions.ShowSplitpane)
    showSplitpane({ patchState }: StateContext<PublicStateModel>) {
        patchState({ showSplitpane: true });
    }

    @Action(PublicStateActions.HideSplitpane)
    hideSplitpane({ patchState }: StateContext<PublicStateModel>) {
        patchState({ showSplitpane: false });
    }
}
